import "@mdi/font/css/materialdesignicons.css";

import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { StringDateAdapter } from "vuetify/date/adapters/string";
import { de } from "vuetify/locale";
import "vuetify/styles";
import "@/scss/fonts.scss";
import "@/scss/main.scss";
import "@/scss/variables.scss";

const light = {
  dark: false,
  colors: {
    primary: process.env.VUE_APP_PRIMARY_COLOR || "#0099DB",
    secondary: process.env.VUE_APP_SECONDARY_COLOR || "#FFCC00",
    surface: process.env.VUE_APP_SURFACE_COLOR || "#FFFFFF",
    "surface-variant": process.env.VUE_APP_SURFACE_VARIANT_COLOR || "#A09F9F",
    "custom-surface-secondary":
      process.env.VUE_APP_CUSTOM_SURFACE_SECONDARY_COLOR || "#FFFFFF",
    accent: process.env.VUE_APP_ACCENT_COLOR || "#e5f5fc",
    error: process.env.VUE_APP_ERROR_COLOR || "#FF5252",
    info: process.env.VUE_APP_INFO_COLOR || "#2196F3",
    success: process.env.VUE_APP_SUCCESS_COLOR || "#4CAF50",
    "custom-success-lighten":
      process.env.VUE_APP_CUSTOM_SUCCESS_LIGHTEN_COLOR || "#DCFFD6",
    "custom-error-lighten":
      process.env.VUE_APP_CUSTOM_ERROR_LIGHTEN_COLOR || "#FFE4d5",
    "custom-success-darker":
      process.env.VUE_APP_CUSTOM_SUCCESS_DARKER_COLOR || "#2D9437",
    "custom-error-darker":
      process.env.VUE_APP_CUSTOM_ERROR_DARKER_COLOR || "#DF323B",
    warning: process.env.VUE_APP_WARNING_COLOR || "#FB8C00",
    "custom-on-warning":
      process.env.VUE_APP_CUSTOM_ON_WARNING_COLOR || "#000000",
    body: process.env.VUE_APP_BODY_COLOR || "#707070",
    darkgrey: process.env.VUE_APP_DARKGREY_COLOR || "#3b3b3b",
  },
  variables: {
    "list-item-subtitle-opacity": 1,
  },
};

const dark = {
  dark: true,
  colors: {
    primary: process.env.VUE_APP_PRIMARY_COLOR_DARK || "#0099DB",
    secondary: process.env.VUE_APP_SECONDARY_COLOR_DARK || "#FFCC00",
    surface: process.env.VUE_APP_SURFACE_COLOR || "#121212",
    "surface-variant": process.env.VUE_APP_SURFACE_VARIANT_COLOR || "#696969",
    "custom-surface-secondary":
      process.env.VUE_APP_CUSTOM_SURFACE_SECONDARY_COLOR || "#1e1e1e",
    accent: process.env.VUE_APP_ACCENT_COLOR_DARK || "#282828",
    error: process.env.VUE_APP_ERROR_COLOR_DARK || "#FF5252",
    info: process.env.VUE_APP_INFO_COLOR_DARK || "#2196F3",
    success: process.env.VUE_APP_SUCCESS_COLOR_DARK || "#4CAF50",
    "custom-success-lighten":
      process.env.VUE_APP_CUSTOM_SUCCESS_LIGHTEN_COLOR || "#DCFFD6",
    "custom-error-lighten":
      process.env.VUE_APP_CUSTOM_ERROR_LIGHTEN_COLOR || "#FFE4d5",
    "custom-success-darker":
      process.env.VUE_APP_CUSTOM_SUCCESS_DARKER_COLOR || "#2D9437",
    "custom-error-darker":
      process.env.VUE_APP_CUSTOM_ERROR_DARKER_COLOR || "#DF323B",
    warning: process.env.VUE_APP_WARNING_COLOR_DARK || "#FB8C00",
    "custom-on-warning":
      process.env.VUE_APP_CUSTOM_ON_WARNING_COLOR || "#FFFFFF",
    darkgrey: process.env.VUE_APP_DARKGREY_COLOR_DARK || "#f5f5f5",
  },
};

export default createVuetify({
  locale: { locale: "de", messages: { de } },
  components,
  directives,
  defaults: {
    VBtn: {
      style: "font-size: 14px; text-transform: none; font-weight: 500;",
    },
    VCheckbox: { color: "primary" },
    VTextField: { color: "primary" },
    VSelect: { color: "primary" },
    VDatePicker: { color: "primary" },
    VTimePicker: { color: "primary" },
    VProgressLinear: { color: "primary" },
    VSwitch: { color: "primary" },
    VRadioGroup: { color: "primary" },
    VSelectionControl: { color: "primary" },
    VTextarea: { color: "primary" },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: { mdi },
  },
  date: {
    adapter: StringDateAdapter,
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light,
      dark,
    },
  },
});
